import React from 'react';
import { Modal, ModalContent, ModalContentProps, ModalProps } from '@tq/ui-components';

export type MobileModalProps = Pick<ModalProps, 'onClose' | 'isOpen' | 'children'> &
  ModalContentProps;
/**
 *
 * Use this to display a full-screen mobile modal
 */
export const MobileModal: React.FC<MobileModalProps> = ({
  isOpen,
  onClose,
  children,

  ...contentProps
}) => (
  <Modal isOpen={isOpen} onClose={onClose} size='full'>
    <ModalContent
      m={0}
      width='100vw'
      minWidth='100vw'
      boxSizing='border-box'
      {...contentProps}
    >
      {children}
    </ModalContent>
  </Modal>
);
